var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',_vm._b({on:{"closed":_vm.onClose}},'modal',{
        width: _vm.width,
        name: _vm.name,
        height: _vm.height,
        resizable: _vm.resizable,
        minWidth: _vm.minWidth,
        minHeight: _vm.minHeight,
        maxHeight: _vm.maxHeight
    },false),[_c('div',{staticClass:"modal-holder"},[_c('i',{staticClass:"uil uil-multiply btn-close",on:{"click":_vm.onClose}}),_c('div',{staticClass:"holder"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }